import React from "react";
import SpinnerDiv from "ui/ReactSpinnerDiv";
import TanStackTable from "root/TanstackTables/TanStackTable";
import IconTooltip from "ui/Tooltip/IconTooltip";
import {ModalLoadSimsTeacherModes} from "root/s360components/Modals/TeacherLoader/useModalLoadSimsTeacher";

export const SIMS_USER_TYPE_STAFF = 1;

export const SIMS_IS_TEACHER = 1;

export const translateIsTeacher = (is_teacher) =>
{
    return is_teacher === SIMS_IS_TEACHER ? 'Teacher' : 'Other' ;
}

const TeacherLoadTable = ({enc_school_id, data, isLoading, onClick}) =>
{
    const actionFormatter = (info) =>
    {
        const row = info.row.original;

        const color = row.is_teacher === SIMS_IS_TEACHER ? 'lightgray' : '#29b41f';
        const disabled = row.is_teacher === SIMS_IS_TEACHER;

        return <div className="action-buttons">
            {disabled === false && <IconTooltip icon='glyphicon-floppy-open' placement='top' text="Assign teacher role" onClick = {() => onClick({ mode: ModalLoadSimsTeacherModes.LOAD, enc_school_id: enc_school_id, row: row }) } color={color}/>}
            {disabled === true && <IconTooltip icon='glyphicon-floppy-open' placement='top' text="Teacher Already Loaded" color={color}/>}
        </div>
    }

    const isTeacherFormatter = (info) =>
    {
        const row = info.row.original;

        return translateIsTeacher(row.is_teacher);
    }

    const columns = [
        {accessorKey: 'firstname', header: 'Firstname', enableSorting: true},
        {accessorKey: 'surname', header: 'Surname', enableSorting: true},
        {accessorKey: 'registration_class', header: 'Registration Class', enableSorting: true},
        {accessorKey: 'teacher_number', header: 'Teacher Number', enableSorting: false},
        {accessorKey: 'wonde_id', header: 'Wonde ID', enableSorting: false},
        {accessorKey: 'mis_id', header: 'MIS ID', enableSorting: false},
        {accessorKey: 'is_teacher', header: 'Role', enableSorting: true, cell: isTeacherFormatter },
        {accessorKey: 'actions', header: 'Actions', enableSorting: false, meta: {textAlign: 'center'}, cell: actionFormatter}
    ];

    return (
        <div className='sims-manager'>
            {isLoading === false && <TanStackTable data={data} columns={columns} showSearch={true}/>}
            {isLoading === true && <SpinnerDiv/>}
        </div>
    )
}

export default TeacherLoadTable;